import { render, staticRenderFns } from "./collectDialog.vue?vue&type=template&id=ae059362&scoped=true"
import script from "./collectDialog.vue?vue&type=script&lang=js"
export * from "./collectDialog.vue?vue&type=script&lang=js"
import style0 from "./collectDialog.vue?vue&type=style&index=0&id=ae059362&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae059362",
  null
  
)

export default component.exports